export default __webpack_public_path__ + "static/media/Transacted.2bcf9946.svg";